import { useEffect, useState } from "react";
import { Table, DatePicker } from "antd";
import type { Dayjs } from "dayjs";
import Form from "react-bootstrap/Form";
import { useGetAllAccountMutation } from "../../redux-toolkit/services/accountMasterService";
import { useGetAllAccountCategoryMutation } from "../../redux-toolkit/services/acountCategoryMasterServices";
import { getLocalStorageData } from "../../utils/LocalStorageService";
import { useDispatch, useSelector } from "react-redux";
import { getAccountCategoryMasterListWithAll, setAllAccountCategoryMaster } from "../../redux-toolkit/slices/accountCategoryMasterSlice";
import { alertMessage } from "../../utils/AlertService";
import { getAccountLedgerData, getAccountLedgerTotalRecords, setAccountLedger } from "../../redux-toolkit/slices/accountLedgerSlice";
import { getLedgerColumns, VOUCHER_FINANCE_COLUMN } from "../constant/AppConstant";
import { useExportLedgerExcelMutation, useGetLedgerMutation } from "../../redux-toolkit/services/accountLedgerServices";
import { getAccountMasterListWithAll, setAllAccountMaster } from "../../redux-toolkit/slices/accountMasterSlice";
import { useSearchVoucherFinanceMutation } from "../../redux-toolkit/services/voucherFinanceService";
import { getVoucherFinanceDataBySearch, getVoucherFinanceTotalRecords, setVoucherFinanceBySearch } from "../../redux-toolkit/slices/voucherFinanceSlice";
import { useAppSelector } from "../../redux-toolkit/hooks";
import { Button } from "react-bootstrap";
import Loading from "../Loading";
import { FiDownload } from "react-icons/fi";

const { RangePicker } = DatePicker;

const AccountLedger = () => {


  const localUserObj: any = getLocalStorageData("localUser");
  const token: any = getLocalStorageData("localUser").token;
  const dispatch = useDispatch();



  const [getAllAccount, getAllAccountResponse] = useGetAllAccountMutation();
  const [getAllAccountCategory, getAllAccountCategoryResponse] = useGetAllAccountCategoryMutation();
  const [getLedgerWithPagination, getLedgerWithPaginationResponse] = useGetLedgerMutation();
  const [getVoucherTypeFinanceBySearch, getVoucherTypeFinanceBySearchResponse] = useSearchVoucherFinanceMutation();
  const [exportLedgerExcel, exportLedgerExcelResponse] = useExportLedgerExcelMutation();

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);
  const [selectedRow, setSelectedRow] = useState<any | null>(null);
  const [dateRange, setDateRange] = useState<[Dayjs | null, Dayjs | null]>([null, null]);
  const [accountCategoryId, setAccountCategoryId] = useState<number>(0);
  const [accountId, setAccountId] = useState<number>(0);
  const [dataSource, setDatasource]: any = useState([]);
  const [voucherDataSource, setVoucherDataSource] = useState<any[]>([]);
  const [voucherPage, setVoucherPage] = useState(1);
  const [voucherPageSize, setVoucherPageSize] = useState(5);


  const accountCategories = useAppSelector(getAccountCategoryMasterListWithAll);
  const accountNames = useAppSelector(getAccountMasterListWithAll);
  const ledgerData: any = useAppSelector(getAccountLedgerData);
  const totalRecords: any = useAppSelector(getAccountLedgerTotalRecords);
  const totalVoucherFinance: any = useAppSelector(getVoucherFinanceTotalRecords)
  const VoucherFinanceSearchData: any = useAppSelector(getVoucherFinanceDataBySearch);



  useEffect(() => {
    getLedgerWithPagination({
      token,
      payload: {
        size: pageSize,
        page: currentPage - 1,
        accountCategoryId: accountCategoryId === 0 ? null : accountCategoryId,
        accountId: accountId === 0 ? null : accountId,
        fromDate: dateRange[0]?.format("YYYY-MM-DD") || null,
        toDate: dateRange[1]?.format("YYYY-MM-DD") || null,
      },
    });
  }, [accountCategoryId, accountId, dateRange, token]);

  useEffect(() => {
    if (getLedgerWithPaginationResponse.isSuccess) {
      dispatch(setAccountLedger(getLedgerWithPaginationResponse.data));
    } else if (getLedgerWithPaginationResponse.isError) {
      const response: any = getLedgerWithPaginationResponse?.error;
      alertMessage(response, "error");
    }
  }, [
    getLedgerWithPaginationResponse.isSuccess,
    getLedgerWithPaginationResponse.isError,
  ]);


  const fetchLedger = (page: number, size: number) => {
    getLedgerWithPagination({
      token,
      payload: {
        size,
        page: page - 1,
        orderBy: "desc",
        accountCategoryId: accountCategoryId === 0 ? null : accountCategoryId,
        accountId: accountId === 0 ? null : accountId,
        fromDate: dateRange[0]?.format("YYYY-MM-DD") || null,
        toDate: dateRange[1]?.format("YYYY-MM-DD") || null,
      },
    });
  };


  useEffect(() => {
    if (ledgerData) {
      setDatasource(ledgerData);
    }
  }, [ledgerData]);


  useEffect(() => {
    getAllAccountCategory({ token: localUserObj?.token });
    getAllAccount({ token: localUserObj?.token });
  }, []);

  useEffect(() => {
    if (getAllAccountCategoryResponse.isSuccess) {
      dispatch(setAllAccountCategoryMaster(getAllAccountCategoryResponse));
    } else if (getAllAccountCategoryResponse.isError) {
      const response: any = getAllAccountCategoryResponse?.error;
      alertMessage(response, "error");
    }
  }, [getAllAccountCategoryResponse.isSuccess, getAllAccountCategoryResponse.isError]);

  useEffect(() => {
    if (getAllAccountResponse.isSuccess) {
      dispatch(setAllAccountMaster(getAllAccountResponse));
    } else if (getAllAccountResponse.isError) {
      const response: any = getAllAccountResponse?.error;
      alertMessage(response, "error");
    }
  }, [getAllAccountResponse.isSuccess, getAllAccountResponse.isError]);

  const paginationChange = (page: number, size: number) => {
    setCurrentPage(page);
    setPageSize(size);
    fetchLedger(page, size);
  };



  const fetchVoucherFinance = (accountName: String, page: number, size: number) => {
    getVoucherTypeFinanceBySearch({
      token: localUserObj?.token,
      payload: {
        pageNumber: page - 1,
        offset: size,
        searchBy: accountName,
        fromDate: dateRange[0]?.format("YYYY-MM-DD") || null,
        toDate: dateRange[1]?.format("YYYY-MM-DD") || null,
      },
    });
    setVoucherPage(page);
    setVoucherPageSize(size);
  };


  useEffect(() => {
    if (getVoucherTypeFinanceBySearchResponse.isSuccess) {
      dispatch(setVoucherFinanceBySearch(getVoucherTypeFinanceBySearchResponse));
    } else if (getVoucherTypeFinanceBySearchResponse.isError) {
      let response: any = getVoucherTypeFinanceBySearchResponse.error;
      alertMessage(response, "error");
    }
  }, [
    getVoucherTypeFinanceBySearchResponse.isSuccess,
    getVoucherTypeFinanceBySearchResponse.isError
  ]);


  useEffect(() => {
    if (VoucherFinanceSearchData) {
      setVoucherDataSource(VoucherFinanceSearchData);
    }
  }, [VoucherFinanceSearchData]);



  const handleExport = async () => {
    await exportLedgerExcel({
      token,
      payload: {
        accountCategoryId: accountCategoryId === 0 ? null : accountCategoryId,
        accountId: accountId === 0 ? null : accountId,
        fromDate: dateRange[0]?.format("YYYY-MM-DD") || null,
        toDate: dateRange[1]?.format("YYYY-MM-DD") || null,
      },
    });
  };


  useEffect(() => {
    if (exportLedgerExcelResponse.isSuccess) {
      alertMessage("Account Ledger Excel export downloaded successfully", "success");
    } else if (exportLedgerExcelResponse.isError) {
      alertMessage("Failed to export Account Ledger", "error");
    }
  }, [
    exportLedgerExcelResponse.isSuccess,
    exportLedgerExcelResponse.isError,
  ]);
  


  return (
    <div className="mt-2 overflow-y-auto px-2">
      <h5 className="mb-3 text-accent fw-bold text-start">Account Ledger</h5>


      {getLedgerWithPaginationResponse.isLoading ||
        getAllAccountCategoryResponse.isLoading ||
        getAllAccountResponse.isLoading ||
        getVoucherTypeFinanceBySearchResponse.isLoading ||
        exportLedgerExcelResponse.isLoading ? (
        <Loading />
      ) : null}

      <div className="row g-3 mb-3">
        <div className="col-12 col-md-6 col-lg-3">
          <label className="form-label">Date Range</label>
          <RangePicker
            value={dateRange}
            onChange={(dates) => setDateRange(dates as [Dayjs | null, Dayjs | null])}
            format="YYYY-MM-DD"
            placeholder={["From Date", "To Date"]}
            className="w-100"
          />
        </div>

        <div className="col-12 col-md-6 col-lg-3">
          <label className="form-label">Account Category</label>
          <select
            className="form-select form-select-sm"
            name="accountCategoryId"
            value={accountCategoryId}
            onChange={(e) => setAccountCategoryId(Number(e.target.value))}
          >
            {accountCategories?.map((cat: any) => (
              <option key={cat.id} value={cat.id}>
                {cat.accountCategoryName}
              </option>
            ))}
          </select>
        </div>

        <div className="col-12 col-md-6 col-lg-3">
          <label className="form-label">Account Name</label>
          <select
            className="form-select form-select-sm"
            name="accountId"
            value={accountId}
            onChange={(e) => setAccountId(Number(e.target.value))}
          >
            {accountNames?.map((acc: any) => (
              <option key={acc.id} value={acc.id}>
                {acc.accountName}
              </option>
            ))}
          </select>
        </div>

        <div className="col-12 col-md-6 col-lg-3 d-flex align-items-end">
          <Button
            variant="success"
            className="w-100"
            onClick={() => handleExport()}
          >
            <FiDownload /> Export to Excel
          </Button>
        </div>
      </div>


      <div className="mt-3 my-2 w-100 overflow-x-auto rounded-3">
        <Table
          bordered
          rowKey="id"
          pagination={{
            total: totalRecords,
            current: currentPage,
            pageSize: pageSize,
            pageSizeOptions: [5, 10, 20],
            onChange: (page, size) => paginationChange(page, size),
          }}
          columns={getLedgerColumns((record) => {
            setSelectedRow(record);
            fetchVoucherFinance(record.accountName, 1, 5);
          })}
          dataSource={dataSource}
        />

      </div>
      {/* Voucher Finance Section */}
      {selectedRow && (
        <div className="mt-4">
          <h5 className="mb-3 text-accent fw-bold text-start">
            Voucher Finance (for {selectedRow.accountName})
          </h5>
          <div className="mt-3 my-2 w-100 overflow-x-auto rounded-3">
            <Table
              bordered
              rowKey="id"
              columns={VOUCHER_FINANCE_COLUMN}
              dataSource={voucherDataSource}
              pagination={{
                total: totalVoucherFinance,
                current: voucherPage,
                pageSize: voucherPageSize,
                pageSizeOptions: [5, 10, 20],
                onChange: (page, size) => fetchVoucherFinance(selectedRow.accountName, page, size),
              }}
            />

          </div>
        </div>
      )}
    </div>
  );
};

export default AccountLedger;
